/**
 * Nmeth Info Service
 * 新方法論資訊 API 服務
 */

import axios from '../api/axios';

const BASE_URL = '/api/nmeth-info';

export interface NmethInfoDetail {
  id: number;
  organization_id: number;
  proposal_id: number;
  type_of_standard: number | null;
  reference_number: string | null;
  received_date: string | null;
  posting_date: string | null;
  nmeth_info_pct: number;
  edit_by: number;
  created_at: string;
  updated_at: string | null;
}

export interface NmethInfoUpdate {
  type_of_standard?: number | null;
  reference_number?: string;
  received_date?: string;
  posting_date?: string;
}

const nmethInfoService = {
  getByProposal: async (proposalId: number): Promise<NmethInfoDetail | null> => {
    const response = await axios.get(`${BASE_URL}/by-proposal/${proposalId}`);
    return response.data;
  },

  update: async (proposalId: number, data: NmethInfoUpdate): Promise<NmethInfoDetail> => {
    const response = await axios.put(`${BASE_URL}/${proposalId}`, data);
    return response.data;
  },
};

export default nmethInfoService;
